if (!customElements.get('featured-collection-pagination')) {
  class FeaturedCollectionPagination extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onClick(event) {
      const link = event.target.closest('a[href]');
      if (!link || link.getAttribute('aria-disabled') === 'true') return;
      event.preventDefault();

      const sectionId = this.dataset.sectionId;
      const url = new URL(link.getAttribute('href'), window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', sectionId);

      const container = document.getElementById(`collection-${sectionId}`);
      if (!container) return;
      container.setAttribute('aria-busy', 'true');
      container.style.opacity = '0.5';

      try {
        const response = await fetch(url.toString());
        const html = await response.text();
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById(`collection-${sectionId}`);
        if (fresh) {
          container.innerHTML = fresh.innerHTML;
          container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const firstLink = container.querySelector('.grid__item a');
          if (firstLink) firstLink.focus({ preventScroll: true });
        } else {
          window.location.href = link.href;
        }
      } catch (e) {
        window.location.href = link.href;
      } finally {
        container.removeAttribute('aria-busy');
        container.style.opacity = '';
      }
    }
  }
  customElements.define('featured-collection-pagination', FeaturedCollectionPagination);
}
